import { createAction } from 'shared/utils';

export const CONFIG_FLOOR_PAGE_REFRESH = 'CONFIG_FLOOR_PAGE_REFRESH';
export const CONFIG_FLOOR_SUBDIVISION_GETS = createAction('CONFIG_FLOOR_SUBDIVISION_GETS');
export const CONFIG_FLOOR_BLOCK_GETS = createAction('CONFIG_FLOOR_BLOCK_GETS');
export const CONFIG_FLOOR_GETS = createAction('CONFIG_FLOOR_GETS');
export const CONFIG_FLOOR_ADD = createAction('CONFIG_FLOOR_ADD');
export const CONFIG_FLOOR_UPDATE = createAction('CONFIG_FLOOR_UPDATE');
export const CONFIG_FLOOR_DELETE = createAction('CONFIG_FLOOR_DELETE');
